import { getAvatarColor } from '@/lib/colors';
import cx from 'classnames';
import * as React from 'react';

interface UserAvatarProps {
  id?: number | string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  picture?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  id,
  firstName,
  lastName,
  email,
  picture,
  size = 'md',
  className,
}) => {
  const avatarColor = getAvatarColor(id);

  const initials = React.useMemo(() => {
    if (firstName || lastName) {
      return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
    }
    if (email) {
      return email[0].toUpperCase();
    }
    return '?';
  }, [firstName, lastName, email]);

  if (picture) {
    return (
      <img
        src={picture}
        alt={`${firstName || ''} ${lastName || ''}`.trim() || email || 'User'}
        className={cx(
          'rounded-full object-cover',
          sizeClasses[size],
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cx(
        'rounded-full flex items-center justify-center font-semibold',
        sizeClasses[size],
        avatarColor.bg,
        avatarColor.text,
        className,
      )}
    >
      {initials}
    </div>
  );
};
